import React from 'react';
import PropTypes from 'prop-types';
import styles from './ClinicalStudy.module.sass';
import BeforeAfterMobile from '../before_after_mobile/BeforeAfterMobile';
import BeforeAfterDesktop from '../before_after_desktop/BeforeAfterDesktop';
import BeforeAfter from '../before_after/BeforeAfter';
import BeforeAfterSnowMushroomImage from '../../../../images/product/snow_mushroom/before_after.png';

const PRODUCT = {
  SKIN_RHYTHM: 0,
  SNOW_MUSHROOM: 1,
};

const PRODUCTS_BY_SLUG = {
  'balancing-clearing-serum': PRODUCT.SKIN_RHYTHM,
  'skinrhythm-balancing-clearing-serum': PRODUCT.SKIN_RHYTHM,
  'snow-mushroom-water-serum-new': PRODUCT.SNOW_MUSHROOM,
};

const STUDY_RESULTS_BY_PRODUCT = {
  [PRODUCT.SKIN_RHYTHM]: {
    results: [
      {
        percent: '100%',
        label: 'skin felt moisturized and clear',
      },
      {
        percent: '96%',
        label: 'visible clearing of skin imperfections',
      },
      {
        percent: '93%',
        label: 'balancing of excess oil/sebum',
      },
      {
        percent: '89%',
        label: 'visible reduction of acne scars',
      },
    ],
    renderDifference: () => (
      <>
        <BeforeAfterDesktop />
        <BeforeAfterMobile />
        <div className={styles['slider-comment']}>
          CLICK THROUGH TO SEE THE RESULTS. CLICK ON AN IMAGE TO EXPAND.
        </div>
      </>
    ),
    comment: '*Independent clinical laboratory reported results in just 4 weeks. Based on a study of 29 women, ages 25-65. Individual results may vary. Tested using Skin Rhythm Balancing & Clearing Serum twice daily.',
  },
  [PRODUCT.SNOW_MUSHROOM]: {
    results: [
      {
        percent: '97%',
        label: 'skin felt hydrated',
      },
      {
        percent: '93%',
        label: 'skin was smoother',
      },
      {
        percent: '90%',
        label: 'visible improvement in clarity & texture',
      },
      {
        percent: '87%',
        label: 'visible reduction in pore size',
      },
    ],
    renderDifference: () => (<BeforeAfter images={[BeforeAfterSnowMushroomImage]} />),
    comment: '*Independent clinical laboratory reported results in just 2 weeks. Based on a study of 31 women, ages 35-60. Individual results may vary. Tested using Snow Mushroom Water Serum twice daily.',
  },
};

function ClinicalStudy(props) {
  const { slug } = props;

  const studyResult = STUDY_RESULTS_BY_PRODUCT[PRODUCTS_BY_SLUG[slug]];

  if (!studyResult) {
    return null;
  }

  return (
    <div className={styles['consumer-study']}>
      <div className={`${styles['study-results']} ${styles['full-width']}`} data-aos="fade-up" data-aos-duration="2000">
        <div className={styles['results-header']}>
          CLINICAL STUDY
        </div>
        <div className={styles['results-table']}>
          <div className={styles['table-header']}>
            % Reported
          </div>
          {studyResult.results.map((result) => (
            <div key={result.label} className={styles['data-row']}>
              <div className={styles['data-percent']}>
                {result.percent}
              </div>
              <div className={styles['data-comment']}>
                {result.label}
              </div>
            </div>
          ))}
        </div>
      </div>
      {studyResult.renderDifference()}
      <div className={styles['fullsize-comment']}>
        {studyResult.comment}
      </div>
    </div>
  );
}

ClinicalStudy.propTypes = {
  slug: PropTypes.string.isRequired,
};

export default ClinicalStudy;
